import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { isNumber } from '@progress/kendo-angular-dropdowns/dist/es2015/util';
import { GridComponent } from '@progress/kendo-angular-grid';
import { filterBy } from '@progress/kendo-data-query';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { EmployeeService } from 'src/app/services/employee.service';
import { ReportParametersDefaultValue } from 'src/app/shared-components/report-dialog/report-parameters-default-value';
import { Browser } from '../../common/browser';
import { FilterDateTimeGrid } from '../../common/filter-date-time-grid';
import { Global } from '../../common/global';
import { GridHelper } from '../../common/grid-helper';
import { ExtendSalaryPeriod } from '../../model/extend-salary-period';
import { TimeEntryRecord } from '../../services/api/api-model';
import { DataService } from '../../services/api/data.service';
import { StaticDataService } from '../../services/api/static-data.service';
import { SessionService } from '../../services/session/session.service';
import { SettingService } from '../../services/setting.service';
import { ReportDialogService } from '../../shared-components/report-dialog/report-dialog.service';
var EmployeeTimeComponent = /** @class */ (function () {
    function EmployeeTimeComponent(employeeService, translateService, dataService, settingService, staticDataService, sessionService, reportDialogService) {
        var _this = this;
        this.employeeService = employeeService;
        this.translateService = translateService;
        this.dataService = dataService;
        this.settingService = settingService;
        this.staticDataService = staticDataService;
        this.sessionService = sessionService;
        this.reportDialogService = reportDialogService;
        this.newEmploymentDialogVisible = false;
        this.selectedRows = [];
        this.defaultRecordValue = {};
        this.createNewEmployeeDialogVisible = false;
        this.filterClear = false;
        this.listClassExcluded = ['EmployeeInfo', 'Footer'];
        this.hasTimeModule = false;
        this.HasEmployment = false;
        this.TimeEntryTypes = [];
        this.TimeEntryRecords = [];
        this.TimeEntryStatuses = [];
        this.allowUsersToModifyOwnData = false;
        this.allowSelfServiceTimeEntry = false;
        this.isDisableAddNew = false;
        this.option = { min: null, step: 1, spinners: false };
        this.dimensionXValues = [];
        this.AllText = 'All';
        this.isSlect1020default = true;
        this.numberOption = { min: null, step: 0, spinners: false, decimals: 2, format: 'n2' };
        /*end variable of approval timeentry*/
        this.preSalaryCycleId = 0;
        this.preSalaryPeriodId = 0;
        this.preStatus = 0;
        this.isErrorApiMessage = false;
        this.ngUnsubscribe = new Subject();
        this.previousAddedTimeEntryUid = [];
        this.isgetNotMatchPeriodMessageString = false;
        this.currentisaddnew = false;
        this.isShowRejectDialog = false;
        this.isShowRejectDialogNonApproveTimeEntry = false;
        this.triggerUpdate = false;
        this.preData = new TimeEntryRecord();
        this.isShowDateErrorInput = false;
        this.isUpdateWarrningPeriods = false;
        this.flagselect = 0;
        this.isShowDeleteRecord = false;
        this.isShowEmployeeTimeApproveDialog = false;
        this.keyPress = { 17: false, 18: false, 107: false, 109: false };
        this.gridData = this.TimeEntryRecords;
        this.expanded = false;
        this.translationServiceTerms = [
            'EmploymentTime.PeriodWarning',
            'CompanySalaryBatches.SalaryCycle_Item_All_Text',
            'EmploymentTime.EligibleForApproval'
        ];
        this.UnitTypes = JSON.parse(JSON.stringify(Global.UNIT_TYPES));
        this.reportDialogService.reportParams = new ReportParametersDefaultValue();
        this.employeeService.employee
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (employee) {
            return (_this.reportDialogService.reportParams.employeeId = employee ? employee.Id : undefined);
        });
        this.employeeService.employment
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (employment) {
            return (_this.reportDialogService.reportParams.employmentId = employment ? employment.Id : undefined);
        });
    }
    Object.defineProperty(EmployeeTimeComponent.prototype, "userEmployment", {
        get: function () {
            return this.privateUserEmployment;
        },
        set: function (value) {
            var _this = this;
            var preUserId;
            if (this.privateUserEmployment) {
                preUserId = this.privateUserEmployment.Id;
            }
            this.updateUnsavedRecords();
            this.privateUserEmployment = value;
            if (!this.privateUserEmployment || !this.privateUserEmployment.Id) {
                this.HasEmployment = false;
                return;
            }
            this.HasEmployment = true;
            if (!preUserId || preUserId !== value.Id) {
                this.filter = null;
                this.filterClear = true;
                this.tempselectedSalaryPeriodId = undefined;
                this.TimeEntryStatuses = [];
                this.TimeEntryRecords = [];
                this.DefaultTimeEntryRecord = [];
                this.newPreviewData = [];
                this.gridData = [];
                this.dataService
                    .TimeEntryTypes_GetTimeEntryTypeViews()
                    .subscribe(function (data) { return _this.onGetTimeEntryTypesCompleted(data); });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "currentCompanyUser", {
        get: function () {
            return this.privateCurrentCompanyUser;
        },
        set: function (value) {
            this.privateCurrentCompanyUser = value;
            this.resetStatusFilter();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isEnableDimensionPreference", {
        get: function () {
            var pref = this.sessionService.getCompanyPreference('Dimension.UseDimensionValueEntities');
            return pref.Value === 'true' ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isEmployeeTimeKeydown", {
        get: function () {
            return this.isEmployeeTimeKeydownValue;
        },
        set: function (value) {
            this.isEmployeeTimeKeydownValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isMobile", {
        get: function () {
            var browser = new Browser();
            return browser.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "noCPRMessage", {
        get: function () {
            return this.currentCompanyUser && this.currentCompanyUser.HasDummyIdentityNumber ? 'Employee.NoValidCPR' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isHideApprovePeriod", {
        get: function () {
            return this.isSelfService || this.IsReadOnly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isHideDimension1", {
        get: function () {
            return this.Dimension1Preference && !!this.Dimension1Preference.Value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isHideDimension2", {
        get: function () {
            return this.Dimension2Preference && !!this.Dimension2Preference.Value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isHideDimension3", {
        get: function () {
            return this.Dimension3Preference && !!this.Dimension3Preference.Value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isSalaryAdminAndHigher", {
        get: function () {
            return (Global.SESSION.CurrentCompanyUser &&
                this.employeeSelectedId !== Global.SESSION.CurrentCompanyUser.Id &&
                this.sessionService.role.IsSalaryAdminAndHigher);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isManager", {
        get: function () {
            return (Global.SESSION.CurrentCompanyUser &&
                this.employeeSelectedId !== Global.SESSION.CurrentCompanyUser.Id &&
                this.sessionService.role.EmployeeWithRoleAsManager);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "Dimension1Name", {
        get: function () {
            if (!this.isHideDimension1) {
                return '';
            }
            else {
                var dimension1Object = this.sessionService.getCompanyPreference('Dimensions.Dimension1Name');
                if (dimension1Object && dimension1Object.Value) {
                    return dimension1Object.Value;
                }
            }
            return '1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "Dimension2Name", {
        get: function () {
            if (!this.isHideDimension2) {
                return '';
            }
            else {
                var dimension2Object = this.sessionService.getCompanyPreference('Dimensions.Dimension2Name');
                if (dimension2Object && dimension2Object.Value) {
                    return dimension2Object.Value;
                }
            }
            return '2';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "Dimension3Name", {
        get: function () {
            if (!this.isHideDimension3) {
                return '';
            }
            else {
                var dimension3Object = this.sessionService.getCompanyPreference('Dimensions.Dimension3Name');
                if (dimension3Object && dimension3Object.Value) {
                    return dimension3Object.Value;
                }
            }
            return '3';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "IsActive", {
        get: function () {
            return (this.sessionService.currentState === 'tabs.employee.time' ||
                this.sessionService.currentState === 'tabs.selfservice.time');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isSelfService", {
        get: function () {
            return this.sessionService.currentState === 'tabs.selfservice.time';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "isEmployeeTabs", {
        get: function () {
            return this.sessionService.currentState.includes('tabs.employee');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "IsReadOnly", {
        get: function () {
            return this.sessionService.role.IsReadOnly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "allowToApprove", {
        get: function () {
            return (this.currentCompanyUser &&
                !(this.sessionService.role.IsEmployeeRole &&
                    Global.SESSION &&
                    Global.SESSION.CurrentCompanyUser.Id === this.currentCompanyUser.Id));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "SelectedSalaryPeriod", {
        get: function () {
            var _this = this;
            if (!this.selectedSalaryPeriodId || !this.SalaryPeriods || this.SalaryPeriods.length <= 0) {
                return undefined;
            }
            return this.SalaryPeriods.filter(function (period) {
                return period.Id === _this.selectedSalaryPeriodId;
            })[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "Dimension1Preference", {
        get: function () {
            return this.sessionService.getCompanyPreference('Dimensions.Dimension1Name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "Dimension2Preference", {
        get: function () {
            return this.sessionService.getCompanyPreference('Dimensions.Dimension2Name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "Dimension3Preference", {
        get: function () {
            return this.sessionService.getCompanyPreference('Dimensions.Dimension3Name');
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTimeComponent.prototype.timeStatusChanged = function () {
        this.filterTimeEntriesByStatus();
    };
    Object.defineProperty(EmployeeTimeComponent.prototype, "isAllowEditGridOption", {
        get: function () {
            var currentState = this.sessionService.currentState;
            switch (currentState) {
                case 'tabs.employee.time':
                    return true;
                case 'tabs.selfservice.time':
                    if (this.allowSelfServiceTimeEntry) {
                        return true;
                    }
                    break;
                default:
                    break;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTimeComponent.prototype, "DisbaleTooltipAddNewEmployeetime", {
        get: function () {
            if (!this.isAllowEditGridOption) {
                return 'EmploymentTime.DisableGridTimeMessage';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTimeComponent.prototype.ngOnInit = function () {
        var _this = this;
        var currentState = this.sessionService.currentState;
        switch (currentState) {
            case 'tabs.employee.time':
                var objectAllowUsersToModifyOwnData = this.sessionService.getCompanyPreference('Access.AllowUsersToModifyOwnData');
                if (objectAllowUsersToModifyOwnData && objectAllowUsersToModifyOwnData.Value === 'true') {
                    this.allowUsersToModifyOwnData = true;
                }
                break;
            case 'tabs.selfservice.time':
                var objectAllowSelfServiceTimeEntry = this.sessionService.getCompanyPreference('Access.AllowSelfServiceTimeEntry');
                if (objectAllowSelfServiceTimeEntry && objectAllowSelfServiceTimeEntry.Value === 'true') {
                    this.allowSelfServiceTimeEntry = true;
                }
                break;
            default:
                break;
        }
        this.employeeService.selectedEmployeeId.subscribe(function (value) {
            _this.employeeSelectedId = value;
        });
        this.sessionService.OnLocationChangeStart.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (transition) {
            if (_this.IsActive) {
                _this.updateUnsavedRecords();
            }
        });
        this.staticDataService.TimeEntryStatus.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (timeEntryStatus) {
            _this.timeEntryStatus = timeEntryStatus;
            if (!_this.timeEntryStatus || (_this.timeEntryStatus && _this.timeEntryStatus.length === 0)) {
                return;
            }
            _this.enableTranslation();
            if (_this.IsActive) {
                _this.settingService.showModuleMessage('Employee.Time');
            }
            _this.updateDimensionValue();
        });
    };
    EmployeeTimeComponent.prototype.updateDimensionValue = function () {
        if (this.Dimension1Preference && this.Dimension1Preference.Value) {
            this.updateDimensionXValues(1);
        }
        if (this.Dimension2Preference && this.Dimension2Preference.Value) {
            this.updateDimensionXValues(2);
        }
        if (this.Dimension3Preference && this.Dimension3Preference.Value) {
            this.updateDimensionXValues(3);
        }
    };
    EmployeeTimeComponent.prototype.updateDimensionXValues = function (index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var employment_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isEnableDimensionPreference) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.employeeService.employment.subscribe(function (data) {
                                employment_1 = data;
                            })];
                    case 1:
                        _a.sent();
                        this.dataService.DimensionValues_GetDimensionValues(index).subscribe(function (data) {
                            _this.dimensionXValues[index - 1] = data.filter(function (value) {
                                if (!value.LimitToDepartmentId && !value.LimitToTemplateId) {
                                    return true;
                                }
                                else if (!value.LimitToDepartmentId) {
                                    if (employment_1.BasedOnTemplateId === value.LimitToTemplateId) {
                                        return true;
                                    }
                                    return false;
                                }
                                else if (!value.LimitToTemplateId) {
                                    if (employment_1.DepartmentId === value.LimitToDepartmentId) {
                                        return true;
                                    }
                                    return false;
                                }
                                else if (value.LimitToDepartmentId && value.LimitToTemplateId) {
                                    if (employment_1.DepartmentId === value.LimitToDepartmentId &&
                                        employment_1.BasedOnTemplateId === value.LimitToTemplateId) {
                                        return true;
                                    }
                                    return false;
                                }
                                return false;
                            });
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        this.dataService.Miscellaneous_GetDimensionValues(index).subscribe(function (data) {
                            _this.dimensionXValues[index - 1] = data.filter(function (value) { return value; });
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmployeeTimeComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EmployeeTimeComponent.prototype.enableTranslation = function () {
        var _this = this;
        this.sessionService.OnTranslateChanged.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function () {
            _this.translateService.get(_this.translationServiceTerms).subscribe(function (translations) {
                _this.setTranslationTerms(translations);
            });
        });
    };
    EmployeeTimeComponent.prototype.setTranslationTerms = function (translations) {
        this.PeriodWarningText = translations['EmploymentTime.PeriodWarning'];
        this.AllText = translations['CompanySalaryBatches.SalaryCycle_Item_All_Text'];
        this.filterEligibleforapproval = translations['EmploymentTime.EligibleForApproval'];
    };
    EmployeeTimeComponent.prototype.onGetTimeEntryTypesCompleted = function (timeEntryTypes) {
        if (timeEntryTypes && timeEntryTypes.length > 0) {
            this.flagselect += 1;
            this.TimeEntryTypes = timeEntryTypes;
            this.TimeEntryTypes.forEach(function (model) {
                model.Id = model.Id || model.BaseTimeEntryTypeId || null;
                model.InternalReferenceId = model.InternalReferenceId ? model.InternalReferenceId : null;
            });
            this.defaultTimeEntryType = timeEntryTypes.find(function (mode) { return mode.Identifier === 'Work'; });
            if (!this.defaultTimeEntryType) {
                this.defaultTimeEntryType = timeEntryTypes[0];
            }
        }
        this.flagselect += 1;
        if (this.TimeEntryTypes && this.TimeEntryTypes.length > 0) {
            this.populateData(this.privateUserEmployment);
        }
    };
    EmployeeTimeComponent.prototype.filterTimeEntriesByStatus = function (dataSource) {
        var _this = this;
        if (this.TimeEntryRecords) {
            if (this.SelectedTimeStatusId >= 0) {
                this.TimeEntryRecords = this.DefaultTimeEntryRecord.filter(function (model) { return model.Status.Id === _this.SelectedTimeStatusId; });
            }
            else {
                this.TimeEntryRecords = this.DefaultTimeEntryRecord;
            }
            if (this.filter && this.filter.filters && this.filter.filters.length > 0) {
                this.onFilterChange(this.filter);
            }
        }
    };
    Object.defineProperty(EmployeeTimeComponent.prototype, "SelectedTimeStatus", {
        get: function () {
            var _this = this;
            return this.TimeEntryStatuses.filter(function (value) { return value.Id === _this.SelectedTimeStatusId; })[0];
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTimeComponent.prototype.resetStatusFilter = function () {
        if (this.TimeEntryStatuses[0]) {
            this.SelectedTimeStatusId = this.TimeEntryStatuses[0].Id;
        }
        this.filterTimeEntriesByStatus();
    };
    EmployeeTimeComponent.prototype.populateTimeEntryGridDataSource = function (userEmploymentId, salaryPeriodId) {
        var _this = this;
        this.dataService
            .TimeEntry_GetTimeEntryRecordsByEmployment(userEmploymentId, salaryPeriodId)
            .subscribe(function (records) {
            if (records && records.length > 0) {
                records.forEach(function (model) {
                    _this.flagselect += 1;
                    _this.updateEditableFieldsAndClasses(model);
                    if (model.EndTime && model.EndTime === '23:59:59.9999999') {
                        model.EndTime = '24:00:00';
                    }
                    model.TimeEntryType =
                        _this.TimeEntryTypes && _this.TimeEntryTypes.length > 0
                            ? _this.TimeEntryTypes.find(function (item) { return item.TimeEntryTypeId === model.TimeEntryTypeId; })
                            : {};
                    model.isAllowEdit =
                        model.Status && model.Status.Key && (model.Status.Key === 'Open' || model.Status.Key === 'Rejected')
                            ? true
                            : false;
                    if (!model.TimeEntryType || model.TimeEntryType === undefined) {
                        model.TimeEntryType = {};
                    }
                    model.TimeEntryType.Id = model.TimeEntryType ? model.TimeEntryType.TimeEntryTypeId : -1;
                    model.TimeEntryTypeName = model.TimeEntryType && model.TimeEntryType.Name ? model.TimeEntryType.Name : '';
                    model.idColumn = _this.flagselect;
                    model.RejectionReason = model.Status && model.Status.Key !== 'Rejected' ? '' : model.RejectionReason;
                });
                _this.newPreviewData = [];
                _this.TimeEntryRecords = [];
                _this.DefaultTimeEntryRecord = [];
                _this.TimeEntryRecords = JSON.parse(JSON.stringify(records));
                _this.DefaultTimeEntryRecord = JSON.parse(JSON.stringify(records));
                _this.populateGridPreview();
                if (!_this.isMobile) {
                    _this.TimeEntryStatuses = [];
                    _this.DefaultTimeEntryRecord.forEach(function (item) {
                        if (item && item.Status) {
                            var isStatusExist = _this.TimeEntryStatuses.filter(function (timeEntryStatus) { return timeEntryStatus.Name === item.Status.Name; }).length > 0;
                            if (!isStatusExist) {
                                _this.TimeEntryStatuses.push(item.Status);
                            }
                        }
                    });
                    _this.TimeEntryStatuses = _this.TimeEntryStatuses.sort(function (s) {
                        return s.Name;
                    });
                    var allStatus = { Id: -1, Name: _this.AllText };
                    _this.TimeEntryStatuses.unshift(allStatus);
                    if (_this.SelectedTimeStatus) {
                        var selectedStatus = _this.TimeEntryStatuses.filter(function (timeEntryStatus) { return timeEntryStatus.Name === _this.SelectedTimeStatus.Name; })[0];
                        _this.SelectedTimeStatusId = selectedStatus ? selectedStatus.Id : allStatus.Id;
                        if (!selectedStatus) {
                            _this.filterTimeEntriesByStatus();
                        }
                    }
                    else {
                        _this.SelectedTimeStatusId = allStatus.Id;
                    }
                    _this.initTimeEntryStatusDataSource();
                }
            }
            else {
                _this.newPreviewData = [];
                _this.TimeEntryRecords = [];
                _this.gridData = [];
                _this.DefaultTimeEntryRecord = [];
                if (!_this.isMobile) {
                    _this.TimeEntryStatuses = [];
                    var allStatus = { Id: -1, Name: _this.AllText };
                    _this.TimeEntryStatuses.unshift(allStatus);
                    _this.SelectedTimeStatusId = allStatus.Id;
                }
            }
            _this.originalTimeEntryRecords = JSON.parse(JSON.stringify(_this.TimeEntryRecords));
        });
    };
    EmployeeTimeComponent.prototype.populateGridPreview = function () {
        var _this = this;
        var previewResultWithKm = [];
        var kmType = Global.UNIT_TYPES
            ? Global.UNIT_TYPES.find(function (type) { return type.Key === 'Kilometers'; })
            : undefined;
        if (this.TimeEntryRecords && this.TimeEntryRecords.length > 0) {
            var previewcheckTimeentryRecord = this.TimeEntryRecords;
            var array = void 0;
            var hasUndefinedItem_1 = false;
            var newArray = void 0;
            array = previewcheckTimeentryRecord.map(function (item, index) {
                var currentTimeEntryType = _this.TimeEntryTypes.find(function (tet) { return tet.TimeEntryTypeId === item.TimeEntryTypeId; });
                if (!currentTimeEntryType) {
                    hasUndefinedItem_1 = true;
                    return undefined;
                }
                var unitType = _this.UnitTypes.find(function (type) { return type.Id === item.UnitTypeId; });
                var previewItem = {
                    Type: currentTimeEntryType.Name,
                    Units: item.Units,
                    UnitName: unitType ? unitType.Name : undefined,
                    KilometersDriven: item.KilometersDriven ? item.KilometersDriven : 0,
                    KilometersDrivenUnitName: kmType ? kmType.Name : ''
                };
                return previewItem;
            });
            if (hasUndefinedItem_1) {
                newArray = array.filter(function (value) {
                    return value !== undefined;
                });
            }
            else {
                newArray = array;
            }
            var previewResult_1 = [];
            newArray.reduce(function (res, value) {
                if (!res[value.Type + value.UnitName]) {
                    res[value.Type + value.UnitName] = {
                        Type: value.Type,
                        UnitName: value.UnitName,
                        Units: value.Units,
                        KilometersDriven: value.KilometersDriven,
                        KilometersDrivenUnitName: value.KilometersDrivenUnitName
                    };
                    previewResult_1.push(res[value.Type + value.UnitName]);
                }
                else {
                    res[value.Type + value.UnitName].Units += value.Units;
                    res[value.Type + value.UnitName].KilometersDriven += value.KilometersDriven;
                }
                return res;
            }, {});
            previewResult_1.reduce(function (res, value) {
                if (value.Units) {
                    previewResultWithKm.push({
                        Type: value.Type,
                        UnitName: value.UnitName,
                        Units: value.Units
                    });
                }
                if (value.KilometersDriven) {
                    var existedByType = previewResultWithKm
                        ? previewResultWithKm.find(function (km) { return km.KmType === true && km.Type === value.Type; })
                        : undefined;
                    if (existedByType) {
                        previewResultWithKm[previewResultWithKm.indexOf(existedByType)].Units += value.KilometersDriven;
                    }
                    else {
                        previewResultWithKm.push({
                            Type: value.Type,
                            Units: value.KilometersDriven,
                            UnitName: value.KilometersDrivenUnitName,
                            KmType: true
                        });
                    }
                }
                return res;
            }, {});
            previewResultWithKm = previewResultWithKm
                .sort(function (first, next) {
                GridHelper.sortByString(first, next, 'KmType');
            })
                .reverse()
                .sort(function (aPreview, bPreview) { return GridHelper.sortByStringValue(aPreview.Type, bPreview.Type); });
            this.newPreviewData = previewResultWithKm;
        }
        else {
            this.newPreviewData = [];
        }
    };
    EmployeeTimeComponent.prototype.initTimeEntryStatusDataSource = function () {
        var _this = this;
        // this.TimeEntryStatuses = [];
        if (this.TimeEntryRecords) {
            this.TimeEntryRecords.forEach(function (item) {
                if (item && item.Status) {
                    var isStatusExist = _this.TimeEntryStatuses.filter(function (timeEntryStatus) { return timeEntryStatus.Name === item.Status.Name; }).length > 0;
                    if (!isStatusExist) {
                        _this.TimeEntryStatuses.push(item.Status);
                    }
                }
            });
        }
        this.TimeEntryStatuses = this.TimeEntryStatuses.sort(function (s) {
            return s.Name;
        });
        var allStatus = { Id: -1, Name: this.AllText };
        if (this.SelectedTimeStatus) {
            var selectedStatus = this.TimeEntryStatuses.find(function (timeEntryStatus) { return timeEntryStatus.Name === _this.SelectedTimeStatus.Name; });
            this.SelectedTimeStatusId = selectedStatus ? selectedStatus.Id : allStatus.Id;
        }
        else {
            this.SelectedTimeStatusId = allStatus.Id;
        }
        this.filterTimeEntriesByStatus();
    };
    EmployeeTimeComponent.prototype.getNotMatchPeriodMessage = function (record) {
        if (record && record.EntryDate) {
            var outOfPeriodDate = void 0;
            var entryDate = record.EntryDate;
            var startDate = new Date(this.SelectedSalaryPeriod.StartDate.toString());
            var endDate = new Date(this.SelectedSalaryPeriod.EndDate.toString());
            endDate.setHours(23, 59, 59);
            if (entryDate < startDate || entryDate > endDate) {
                outOfPeriodDate = record.EntryDate;
            }
            else {
                outOfPeriodDate = record.EndDate;
            }
            return this.PeriodWarningText.replace('$$$', this.sessionService.toString(outOfPeriodDate));
        }
        return '';
    };
    EmployeeTimeComponent.prototype.populateData = function (userEmployment) {
        var _this = this;
        if (userEmployment) {
            this.dataService
                .SalaryBatches_GetSalaryPeriods(userEmployment.SalaryCycleId)
                .subscribe(function (salaryPeriods) {
                if (salaryPeriods.length <= 0) {
                    _this.SalaryPeriods = [];
                    _this.TimeEntryRecords = [];
                    _this.gridData = [];
                    _this.DefaultTimeEntryRecord = [];
                    _this.newPreviewData = [];
                    return;
                }
                _this.SalaryPeriods = [];
                salaryPeriods = salaryPeriods.sort(function (data1, data2) {
                    return GridHelper.sortByDateValue(data1.StartDate, data2.StartDate);
                });
                if (salaryPeriods) {
                    salaryPeriods.forEach(function (salaryPeriod, key) {
                        var startDate = _this.sessionService.toString(salaryPeriod.StartDate ? new Date(salaryPeriod.StartDate) : undefined);
                        var endDate = _this.sessionService.toString(salaryPeriod.EndDate ? new Date(salaryPeriod.EndDate) : undefined);
                        var isUserFriendlyname = _this.sessionService.getCompanyPreference('SalaryPeriods.FriendlyNames');
                        if (isUserFriendlyname && isUserFriendlyname.Value === 'true') {
                            var extendSalaryPeriod = new ExtendSalaryPeriod();
                            extendSalaryPeriod.Id = salaryPeriod.Id;
                            extendSalaryPeriod.StartDate = salaryPeriod.StartDate;
                            extendSalaryPeriod.EndDate = salaryPeriod.EndDate;
                            extendSalaryPeriod.Period = startDate + ' - ' + endDate;
                            extendSalaryPeriod.FriendlyName = ' ' + salaryPeriod.FriendlyName;
                            _this.SalaryPeriods[key] = extendSalaryPeriod;
                        }
                        else {
                            var extendSalaryPeriod = new ExtendSalaryPeriod();
                            extendSalaryPeriod.Id = salaryPeriod.Id;
                            extendSalaryPeriod.StartDate = salaryPeriod.StartDate;
                            extendSalaryPeriod.EndDate = salaryPeriod.EndDate;
                            extendSalaryPeriod.Period = startDate + ' - ' + endDate;
                            extendSalaryPeriod.FriendlyName = startDate + ' - ' + endDate;
                            _this.SalaryPeriods[key] = extendSalaryPeriod;
                        }
                    });
                }
                var roleId = _this.currentCompanyUser ? _this.currentCompanyUser.RoleId : undefined;
                _this.setDefaultSalaryPeriod(roleId, userEmployment);
            });
        }
    };
    EmployeeTimeComponent.prototype.ApproveEntries = function () {
        this.isShowEmployeeTimeApproveDialog = true;
    };
    EmployeeTimeComponent.prototype.setDefaultSalaryPeriod = function (roleId, userEmployment) {
        var _this = this;
        if (this.sessionService.currentSalaryCycleId &&
            this.sessionService.currentSalaryPeriodId &&
            this.sessionService.currentSalaryCycleId === this.privateUserEmployment.SalaryCycleId) {
            this.selectedSalaryPeriodId = this.sessionService.currentSalaryPeriodId;
            this.onSalaryPeriodChanged('');
        }
        else {
            var employeeRoleId = 20;
            if (roleId > employeeRoleId) {
                this.dataService
                    .SalaryBatches_SuggestSalaryPeriod(userEmployment.SalaryCycleId)
                    .pipe(finalize(function () {
                    _this.onSalaryPeriodChanged('');
                }))
                    .subscribe(function (salaryPeriod) {
                    if (!salaryPeriod) {
                        return;
                    }
                    _this.selectedSalaryPeriodId = salaryPeriod.Id;
                    if (_this.SalaryPeriods &&
                        _this.SalaryPeriods.length > 0 &&
                        !_this.SalaryPeriods.find(function (item) { return item.Id === salaryPeriod.Id; })) {
                        _this.selectedSalaryPeriodId = _this.SalaryPeriods[0].Id;
                    }
                    if (_this.newRecordDefault) {
                        _this.newRecordDefault.EntryDate = new Date(salaryPeriod.StartDate.toString());
                    }
                });
            }
            else {
                var today_1 = this.staticDataService.getCurrentdate();
                today_1.setHours(0, 0, 0, 0);
                var selectedSalaryPeriod = this.SalaryPeriods.find(function (salaryPeriod) {
                    var startDate = new Date(salaryPeriod.StartDate.toString());
                    var endDate = new Date(salaryPeriod.EndDate.toString());
                    startDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    return startDate <= today_1 && endDate >= today_1;
                });
                this.selectedSalaryPeriodId = selectedSalaryPeriod.Id;
                this.onSalaryPeriodChanged('');
            }
        }
    };
    EmployeeTimeComponent.prototype.onSalaryPeriodChanged = function (value) {
        if (this.selectedSalaryPeriodId && this.selectedSalaryPeriodId !== this.tempselectedSalaryPeriodId) {
            this.sessionService.currentSalaryCycleId = this.privateUserEmployment.SalaryCycleId;
            this.sessionService.currentSalaryPeriodId = this.selectedSalaryPeriodId;
            this.tempselectedSalaryPeriodId = this.selectedSalaryPeriodId;
            this.populateTimeEntryGridDataSource(this.userEmployment.Id, this.selectedSalaryPeriodId);
        }
    };
    EmployeeTimeComponent.prototype.createUserEmployment = function () {
        if (!this.hasTimeModule) {
            return;
        }
        this.newEmploymentDialogVisible = true;
    };
    Object.defineProperty(EmployeeTimeComponent.prototype, "isAddNew", {
        get: function () {
            return this.currentisaddnew;
        },
        set: function (value) {
            this.currentisaddnew = value;
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTimeComponent.prototype.updateUnitsByDateAndTime = function (model) {
        var uniType = model.UnitTypeId && this.UnitTypes ? this.UnitTypes.find(function (type) { return type.Id === model.UnitTypeId; }) : undefined;
        var isHoursUnitType = uniType && uniType.Key === 'Hours';
        var isDaysUnitType = uniType && uniType.Key === 'Days';
        var start;
        if (model.StartTime) {
            start = this.staticDataService.getCurrentdate();
            start.setHours(this.sessionService.parseInt(model.StartTime.split(':')[0]), this.sessionService.parseInt(model.StartTime.split(':')[1]), 0, 0);
        }
        var end;
        if (model.EndTime) {
            end = this.staticDataService.getCurrentdate();
            end.setHours(this.sessionService.parseInt(model.EndTime.split(':')[0]), this.sessionService.parseInt(model.EndTime.split(':')[1]), 0, 0);
        }
        model.StartTime = start ? this.sessionService.toString(start, 'HH:mm:ss') : '';
        model.EndTime = end
            ? model.EndTime.indexOf('24:00') === 0
                ? '24:00:00'
                : this.sessionService.toString(end, 'HH:mm:ss')
            : '';
        if (isHoursUnitType) {
            if (start && end) {
                start.setHours(start.getHours(), start.getMinutes(), 0, 0);
                var startTime = start.getTime();
                var endTime = void 0;
                if (model.EntryDate && model.EndDate) {
                    var entryDate = new Date(model.EntryDate);
                    var endDate = new Date(model.EndDate);
                    startTime = entryDate.setHours(start.getHours(), start.getMinutes(), 0, 0);
                    endTime = endDate.setHours(end.getHours(), end.getMinutes(), 0, 0);
                }
                else {
                    end.setHours(end.getHours(), end.getMinutes(), 0, 0);
                    endTime = end;
                    endTime = start > end ? endTime.setDate(end.getDate() + 1) : endTime.getTime();
                }
                var timeDiff = endTime - startTime;
                model.Units = Math.abs(Math.floor(timeDiff / 3600) / 1000);
            }
            ////else {
            ////    this.calculateUnitByStartAndEndDate(model, isHoursUnitType);
            ////}
        }
    };
    EmployeeTimeComponent.prototype.onSelectRow = function (event) {
        if (!event || event === undefined) {
            return;
        }
        this.updateDimensionValue();
        this.selectedItem = event;
        this.selectedMinDate = this.staticDataService.getCurrentdate(false, event.EntryDate);
        this.selectedEntryDate = event.EntryDate;
        if (event && event.Id && event.EmployeeName && event.UserEmploymentId) {
            this.selectedemployeeIdinGrid = event.UserEmploymentId;
            this.nameEmployeeSelect = event.EmployeeName;
        }
    };
    EmployeeTimeComponent.prototype.onGridButtonClick = function (event) {
        if (event && event.dataItem && event.buttonAction && event.buttonAction === 'Reject') {
            this.selectedemployeeIdinGrid = event.dataItem.Id;
            this.preUserEmploymentId = event.dataItem.UserEmploymentId;
            this.isShowRejectDialogNonApproveTimeEntry = true;
        }
    };
    EmployeeTimeComponent.prototype.onCloseNotMatchPeriodMessage = function (event) {
        var _this = this;
        if (event) {
            if (this.indexRemovePeriod > -1) {
                setTimeout(function () {
                    _this.TimeEntryRecords.splice(_this.indexRemovePeriod, 1);
                    _this.indexRemovePeriod = -1;
                });
            }
        }
    };
    EmployeeTimeComponent.prototype.onRejectDialog = function (event) {
        var _this = this;
        if (event) {
            if (event === 'RejectPrimary') {
                var rejectionInfo = { Reason: this.rejectMessage };
                this.dataService.TimeEntry_RejectTimeEntryRecord(this.selectedemployeeIdinGrid, rejectionInfo).subscribe(function () {
                    _this.rejectMessage = undefined;
                    _this.populateTimeEntryGridDataSource(_this.userEmployment.Id, _this.SelectedSalaryPeriod.Id);
                }, function () {
                    _this.rejectMessage = undefined;
                });
            }
            else {
                this.rejectMessage = undefined;
                this.selectedemployeeIdinGrid = this.preUserEmploymentId;
            }
        }
    };
    EmployeeTimeComponent.prototype.updateUnsavedRecords = function (dataItem) {
        var _this = this;
        var unSavedTimeEntry = this.TimeEntryRecords
            ? this.TimeEntryRecords.filter(function (entry) { return entry.UnSaved; })
            : undefined;
        if (unSavedTimeEntry && unSavedTimeEntry.length > 0) {
            unSavedTimeEntry.forEach(function (entry) {
                if (!dataItem || dataItem.idColumn !== entry.idColumn) {
                    _this.onSaveChangeGrid({ dataItem: entry }, true);
                }
            });
        }
    };
    EmployeeTimeComponent.prototype.oncellCloseEvent = function (event) {
        if (event && event.dataItem && event.dataItem.EntryDate) {
            this.selectedMinDate = this.staticDataService.getCurrentdate(false, event.dataItem.EntryDate);
        }
        if (this.preventCellChangeEvent) {
            this.preventCellChangeEvent = false;
            return;
        }
        if (event && event.dataItem && event.dataItem.UnSaved && !event.sender.isEditing()) {
            this.onSaveChangeGrid({ dataItem: event.dataItem }, true);
        }
    };
    EmployeeTimeComponent.prototype.sort = function () {
        this.TimeEntryRecords = this.TimeEntryRecords.sort(function (data1, data2) {
            return GridHelper.sortDescendingByDateValue(new Date(data1.EntryDate).getTime(), new Date(data2.EntryDate).getTime());
        });
        this.gridData = filterBy(this.TimeEntryRecords, this.filter);
        this.triggerUpdate = true;
    };
    EmployeeTimeComponent.prototype.onSaveChangeGrid = function (event, force) {
        var _this = this;
        if (this.isNotChange) {
            this.isNotChange = false;
            return;
        }
        if (event && event.dataItem) {
            var startdate = event.dataItem.EntryDate
                ? new Date(new Date(event.dataItem.EntryDate).setHours(0)).getTime()
                : undefined;
            var enddate = event.dataItem.EndDate
                ? new Date(new Date(event.dataItem.EndDate).setHours(0)).getTime()
                : undefined;
            if (!event.dataItem.TimeEntryTypeId || !event.dataItem.EntryDate) {
                return;
            }
            else if (!force &&
                event.dataItem.UnitTypeId === 1 &&
                !event.dataItem.EndDate &&
                (event.dataItem.Units === null || event.dataItem.Units === undefined)) {
                // Days Unit type must require either Units or EndDate.
                event.dataItem.UnSaved = true;
                return;
            }
            else if (!force &&
                event.dataItem.UnitTypeId !== 1 &&
                (event.dataItem.Units === null || event.dataItem.Units === undefined)) {
                // Not Days Unit type must require Units.
                event.dataItem.UnSaved = true;
                return;
            }
            event.dataItem.UnSaved = false;
            if (!event.dataItem.Id) {
                if (event.dataItem && event.dataItem.EntryDate) {
                    var entryDate = event.dataItem.EntryDate;
                    var modelEndDate = event.dataItem.EndDate;
                    var startDate = new Date(this.SelectedSalaryPeriod.StartDate.toString());
                    var endDate = new Date(this.SelectedSalaryPeriod.EndDate.toString());
                    endDate.setHours(23, 59, 59);
                    if (entryDate < startDate || entryDate >= endDate) {
                        this.getNotMatchPeriodMessageString = this.PeriodWarningText.replace('$$$', this.sessionService.toString(entryDate));
                        this.isgetNotMatchPeriodMessageString = true;
                        this.indexRemovePeriod = this.TimeEntryRecords.indexOf(event.dataItem, 0);
                    }
                }
                if (!event.dataItem.SalaryPeriodId) {
                    event.dataItem.SalaryPeriodId = this.selectedSalaryPeriodId;
                }
                if (!event.dataItem.UserEmploymentId) {
                    event.dataItem.UserEmploymentId = this.userEmployment.Id;
                }
                event.dataItem.ApprovedUserId = event.dataItem.ApprovedUserId || null;
                event.dataItem.RejectedUserId = event.dataItem.RejectedUserId || null;
                if (this.preData !== event.dataItem) {
                    this.preData = event.dataItem;
                    var uniType_1 = this.UnitTypes
                        ? this.UnitTypes.find(function (type) { return type.Id === event.dataItem.UnitTypeId; })
                        : undefined;
                    if (uniType_1 && uniType_1.Key === 'Days' && !event.dataItem.EndDate && !event.dataItem.Units) {
                        event.dataItem.Units = 1;
                    }
                    var newRecord_1 = Object.assign({}, event.dataItem);
                    newRecord_1.StartTime =
                        newRecord_1.StartTime && newRecord_1.StartTime.indexOf('24:00') === 0 ? '1.00:00:00' : newRecord_1.StartTime;
                    newRecord_1.EndTime =
                        newRecord_1.EndTime && newRecord_1.EndTime.indexOf('24:00') === 0 ? '1.00:00:00' : newRecord_1.EndTime;
                    newRecord_1 = this.createTimeEntryRecord(newRecord_1);
                    this.dataService.TimeEntry_CreateTimeEntryRecord(newRecord_1).subscribe(function (updatedRecord) {
                        event.dataItem.Id = updatedRecord.Id;
                        event.dataItem.UnSaved = false;
                        _this.flagselect += 1;
                        if (updatedRecord.SalaryPeriodId !== _this.selectedSalaryPeriodId) {
                            _this.getNotMatchPeriodMessageString = _this.getNotMatchPeriodMessage(newRecord_1);
                            _this.isgetNotMatchPeriodMessageString = true;
                            _this.indexRemovePeriod = _this.TimeEntryRecords.indexOf(event.dataItem, 0);
                            // Prevent change event 1 time when got dialog error
                            _this.preventCellChangeEvent = true;
                        }
                        else {
                            if (!_this.DefaultTimeEntryRecord.find(function (item) { return item.Id === event.dataItem.Id; })) {
                                _this.DefaultTimeEntryRecord.push(event.dataItem);
                            }
                            if ((uniType_1.Key === 'Days' && updatedRecord.Units) || uniType_1.Key !== 'Days') {
                                event.dataItem.Units = updatedRecord.Units;
                            }
                            _this.assignToOriginalObject(event.dataItem);
                            _this.populateGridPreview();
                            _this.triggerUpdate = true;
                        }
                    }, function (error) {
                        console.error('Create request failed:' + error);
                        _this.populateTimeEntryGridDataSource(_this.userEmployment.Id, _this.SelectedSalaryPeriod.Id);
                        _this.selectedMinDate = _this.staticDataService.getCurrentdate(false, event.dataItem.EntryDate);
                    });
                }
            }
            else {
                var uniType = this.UnitTypes
                    ? this.UnitTypes.find(function (type) { return type.Id === event.dataItem.UnitTypeId; })
                    : undefined;
                if (uniType && uniType.Key === 'Days' && !event.dataItem.EndDate && !event.dataItem.Units) {
                    event.dataItem.Units = 1;
                }
                var updateRecord = Object.assign({}, event.dataItem);
                updateRecord.StartTime =
                    updateRecord.StartTime && updateRecord.StartTime.indexOf('24:00') === 0
                        ? '1.00:00:00'
                        : updateRecord.StartTime;
                updateRecord.EndTime =
                    updateRecord.EndTime && updateRecord.EndTime.indexOf('24:00') === 0 ? '1.00:00:00' : updateRecord.EndTime;
                var modelrequest = this.createTimeEntryRecord(updateRecord);
                this.dataService.TimeEntry_UpdateTimeEntryRecord(modelrequest).subscribe(function (updatedRecord) {
                    _this.flagselect += 1;
                    var record = updatedRecord.length > 0 ? updatedRecord[0] : updatedRecord; //// updatedRecords[0];
                    if (record && record.SalaryPeriodId !== event.dataItem.SalaryPeriodId) {
                        _this.getNotMatchPeriodMessageString = _this.getNotMatchPeriodMessage(event.dataItem);
                        _this.isgetNotMatchPeriodMessageString = true;
                        _this.populateTimeEntryGridDataSource(_this.userEmployment.Id, _this.SelectedSalaryPeriod.Id);
                    }
                    Object.assign(event.dataItem, record);
                    event.dataItem.RejectionReason = record.RejectionReason =
                        event.dataItem.Status && event.dataItem.Status.Key !== 'Rejected' ? '' : event.dataItem.RejectionReason;
                    _this.filterTimeEntriesByStatus();
                    _this.assignToOriginalObject(record);
                    _this.populateGridPreview();
                    _this.updateEditableFieldsAndClasses(event.dataItem);
                    _this.triggerUpdate = true;
                }, function (error) {
                    console.error('Update request failed:' + error);
                    var original = _this.getOriginalObject(event.dataItem.Id);
                    if (original) {
                        Object.assign(event.dataItem, original);
                        _this.selectedMinDate = _this.staticDataService.getCurrentdate(false, event.dataItem.EntryDate);
                        _this.updateEditableFieldsAndClasses(event.dataItem);
                        _this.triggerUpdate = true;
                    }
                    // this.populateTimeEntryGridDataSource(this.userEmployment.Id, this.SelectedSalaryPeriod.Id);
                });
            }
        }
    };
    EmployeeTimeComponent.prototype.RightValue = function (value) {
        if (value) {
            return value;
        }
        return null;
    };
    EmployeeTimeComponent.prototype.createTimeEntryRecord = function (model) {
        return {
            UnitType: this.RightValue(model.UnitType),
            Status: this.RightValue(model.Status),
            EmployeeName: this.RightValue(model.EmployeeName),
            Title: this.RightValue(model.Title),
            DepartmentName: this.RightValue(model.DepartmentName),
            IsCalculated: model.IsCalculated || false,
            CalculatedPayout: isNumber(model.CalculatedPayout) ? model.CalculatedPayout : null,
            AmountPerUnit: this.RightValue(model.AmountPerUnit),
            Id: this.RightValue(model.Id),
            UserEmploymentId: this.RightValue(model.UserEmploymentId),
            EntryDate: this.RightValue(model.EntryDate),
            TimeEntryTypeId: this.RightValue(model.TimeEntryTypeId),
            Units: this.RightValue(model.Units),
            UnitTypeId: this.RightValue(model.UnitTypeId),
            Description: this.RightValue(model.Description),
            SalaryPeriodId: this.RightValue(model.SalaryPeriodId),
            StatusId: this.RightValue(model.StatusId),
            Created: this.RightValue(model.Created),
            RejectionReason: this.RightValue(model.RejectionReason),
            SalaryRecordId: this.RightValue(model.SalaryRecordId),
            SalaryStatementId: this.RightValue(model.SalaryStatementId),
            KilometersDriven: this.RightValue(model.KilometersDriven),
            StartTime: this.RightValue(model.StartTime),
            EndTime: this.RightValue(model.EndTime),
            Dimension1Value: this.RightValue(model.Dimension1Value),
            Dimension2Value: this.RightValue(model.Dimension2Value),
            Dimension3Value: this.RightValue(model.Dimension3Value),
            Dimension1ValueId: this.RightValue(model.Dimension1ValueId),
            Dimension2ValueId: this.RightValue(model.Dimension2ValueId),
            Dimension3ValueId: this.RightValue(model.Dimension3ValueId),
            EndDate: this.RightValue(model.EndDate),
            CalculatedFromRecordId: this.RightValue(model.CalculatedFromRecordId),
            ExternalIdentifier: this.RightValue(model.ExternalIdentifier),
            CalculatedPayoutKilometers: 0,
            ApprovedUserId: this.RightValue(model.ApprovedUserId),
            RejectedUserId: this.RightValue(model.RejectedUserId)
        };
    };
    EmployeeTimeComponent.prototype.assignToOriginalObject = function (timeEntry) {
        if (!timeEntry) {
            return;
        }
        var original = this.originalTimeEntryRecords
            ? this.originalTimeEntryRecords.find(function (item) { return item.Id === timeEntry.Id; })
            : undefined;
        if (original) {
            Object.assign(original, JSON.parse(JSON.stringify(timeEntry)));
        }
        else {
            this.originalTimeEntryRecords.push(JSON.parse(JSON.stringify(timeEntry)));
        }
    };
    EmployeeTimeComponent.prototype.getOriginalObject = function (id) {
        return this.originalTimeEntryRecords
            ? this.originalTimeEntryRecords.find(function (item) { return item.Id === id; })
            : undefined;
    };
    EmployeeTimeComponent.prototype.onControlDataChange = function (event) {
        if (event && event.dataItem && event.field) {
            switch (event.field) {
                case 'TimeEntryTypeId':
                    if (event.dataItem.TimeEntryTypeId) {
                        var timeEntryType = this.TimeEntryTypes
                            ? this.TimeEntryTypes.find(function (e) { return e.TimeEntryTypeId === event.dataItem.TimeEntryTypeId; })
                            : undefined;
                        if (timeEntryType) {
                            event.dataItem.TimeEntryType = timeEntryType;
                            event.dataItem.TimeEntryType.Id = timeEntryType.TimeEntryTypeId;
                        }
                        if (this.TimeEntryTypes && this.TimeEntryTypes.length > 0 && event.dataItem.TimeEntryTypeId) {
                            var newTimeEntryType_1 = this.TimeEntryTypes.find(function (tet) { return tet.TimeEntryTypeId === event.dataItem.TimeEntryTypeId; });
                            event.dataItem.Description = newTimeEntryType_1.Description;
                            event.dataItem.UnitTypeId = newTimeEntryType_1.UnitTypeId
                                ? newTimeEntryType_1.UnitTypeId
                                : this.UnitTypes && this.UnitTypes.length > 0
                                    ? this.UnitTypes[0].Id
                                    : undefined;
                            if (newTimeEntryType_1.UnitTypeId) {
                                event.dataItem.UnitType = this.UnitTypes.find(function (type) { return type.Id === newTimeEntryType_1.UnitTypeId; });
                            }
                        }
                    }
                    ////else {
                    ////    this.populateTimeEntryGridDataSource(this.userEmployment.Id, this.SelectedSalaryPeriod.Id);
                    ////    return;
                    ////}
                    break;
                case 'EntryDate':
                    if (event && event.dataItem && !event.dataItem.EntryDate) {
                        event.dataItem.EntryDate = this.selectedEntryDate;
                        this.isNotChange = true;
                    }
                    break;
                case 'UnitTypeId':
                    var uniType = this.UnitTypes
                        ? this.UnitTypes.find(function (type) { return type.Id === event.dataItem.UnitTypeId; })
                        : undefined;
                    if (uniType && uniType.Key !== 'Hours') {
                        event.dataItem.StartTime = undefined;
                        event.dataItem.EndTime = undefined;
                    }
                    // if (uniType && uniType.Key === 'Days' && !event.dataItem.EndDate) {
                    //   event.dataItem.Units = 1;
                    // }
                    break;
                case 'EndDate':
                    var startDate = event.dataItem.EntryDate
                        ? new Date(new Date(event.dataItem.EntryDate).setHours(0)).getTime()
                        : undefined;
                    var endDate = event.dataItem.EndDate
                        ? new Date(new Date(event.dataItem.EndDate).setHours(0)).getTime()
                        : undefined;
                    if (startDate && endDate && startDate > endDate) {
                        try {
                            event.dataItem.EndDate = undefined;
                        }
                        catch (e) {
                            console.log(e);
                        }
                        this.isShowDateErrorInput = true;
                        return;
                    }
                    break;
                default:
                    break;
            }
            if (event.dataItem.EndTime === '24:00') {
                event.dataItem.EndTime = '24:00:00';
            }
            this.updateEditableFieldsAndClasses(event.dataItem);
            var startdate = new Date(event.dataItem.EntryDate).getTime();
            var enddate = new Date(event.dataItem.EndDate).getTime();
            if (startdate && enddate && startdate > enddate) {
                return;
            }
            this.updateUnitsByDateAndTime(event.dataItem);
        }
    };
    EmployeeTimeComponent.prototype.defaultRecord = function () {
        var _this = this;
        var today = this.staticDataService.getCurrentdate();
        this.flagselect += 1;
        var defaultTypeEntryType = this.defaultTimeEntryType ? this.defaultTimeEntryType : null;
        var defaultUnitType = defaultTypeEntryType
            ? this.UnitTypes
                ? this.UnitTypes.find(function (type) { return type.Id === defaultTypeEntryType.UnitTypeId; })
                : null
            : null;
        defaultUnitType = defaultUnitType ? defaultUnitType : this.UnitTypes ? this.UnitTypes[0] : null;
        this.newRecordDefault = {
            Id: null,
            isAllowEdit: true,
            TimeEntryTypeId: defaultTypeEntryType ? defaultTypeEntryType.TimeEntryTypeId : null,
            EntryDate: today,
            EndDate: null,
            Units: null,
            StartTime: null,
            EndTime: null,
            Description: null,
            DepartmentName: null,
            UnitTypeId: defaultUnitType ? defaultUnitType.Id : null,
            UnitType: defaultUnitType ? defaultUnitType : null,
            Created: today,
            SalaryPeriodId: this.selectedSalaryPeriodId,
            UserEmploymentId: this.userEmployment ? this.userEmployment.Id : null,
            Status: this.timeEntryStatus ? this.timeEntryStatus.find(function (model) { return model.Id === 10; }) : null,
            idColumn: this.flagselect,
            UnSaved: true,
            KilometersDriven: null,
            TimeEntryTypeName: defaultTypeEntryType && defaultTypeEntryType.Name ? defaultTypeEntryType.Name : '',
            TimeEntryType: defaultTypeEntryType,
            CalculatedPayoutKilometers: 0
        };
        if (this.SalaryPeriods && this.SalaryPeriods.length > 0 && this.selectedSalaryPeriodId) {
            var salaryPeriod = this.SalaryPeriods.find(function (model) { return model.Id === _this.selectedSalaryPeriodId; });
            if (salaryPeriod) {
                if (new Date(this.newRecordDefault.EntryDate) < new Date(salaryPeriod.StartDate) ||
                    new Date(this.newRecordDefault.EntryDate) > new Date(salaryPeriod.EndDate)) {
                    this.newRecordDefault.EntryDate = salaryPeriod.StartDate;
                }
            }
        }
        if (this.isHideDimension1) {
            this.newRecordDefault.Dimension1Value = undefined;
        }
        if (this.isHideDimension2) {
            this.newRecordDefault.Dimension2Value = undefined;
        }
        if (this.isHideDimension3) {
            this.newRecordDefault.Dimension3Value = undefined;
        }
        this.newRecordDefault.TimeEntryType =
            this.TimeEntryTypes && this.TimeEntryTypes.length > 0
                ? this.TimeEntryTypes.find(function (item) { return item.TimeEntryTypeId === _this.newRecordDefault.TimeEntryTypeId; })
                : undefined;
        this.updateEditableFieldsAndClasses(this.newRecordDefault);
        return this.newRecordDefault;
    };
    EmployeeTimeComponent.prototype.onUpdateDefaultRecord = function () {
        this.defaultRecordValue = this.defaultRecord();
    };
    EmployeeTimeComponent.prototype.onAddNewRecord = function (event) {
        this.updateUnsavedRecords(event);
    };
    EmployeeTimeComponent.prototype.onDeleteRow = function (event) {
        if (event && event.dataItem) {
            if (event.dataItem.Id) {
                this.IdDelete = event.dataItem.Id;
                this.itemremmove = event.dataItem;
                this.isShowDeleteRecord = true;
            }
            else {
                var indexRemove = this.TimeEntryRecords.indexOf(event.dataItem);
                if (indexRemove !== -1) {
                    this.TimeEntryRecords.splice(indexRemove, 1);
                    this.triggerUpdate = true;
                }
            }
        }
    };
    EmployeeTimeComponent.prototype.onDeleteRecordAction = function (event) {
        var _this = this;
        if (event && event === 'Delete') {
            this.dataService.TimeEntry_DeleteTimeEntryRecord(this.IdDelete).subscribe(function () {
                var indexRemove = _this.TimeEntryRecords.indexOf(_this.itemremmove);
                if (indexRemove !== -1) {
                    _this.TimeEntryRecords.splice(indexRemove, 1);
                    _this.triggerUpdate = true;
                }
                if (_this.TimeEntryRecords.length > 0) {
                    var index = indexRemove > _this.TimeEntryRecords.length - 1 ? 0 : indexRemove;
                    _this.kendoGrid.editCell(index, 0, _this.createFormGroup(_this.itemremmove));
                }
                _this.populateGridPreview();
            }, function (error) {
                console.error('Delete request failed:' + error);
                _this.populateTimeEntryGridDataSource(_this.userEmployment.Id, _this.SelectedSalaryPeriod.Id);
            });
        }
    };
    EmployeeTimeComponent.prototype.onEmployeeTimeApproveDialog = function (event) {
        var _this = this;
        if (event && event === 'Approve') {
            this.dataService
                .TimeEntry_ApprovePeriodForEmployee(this.userEmployment.Id, this.selectedSalaryPeriodId)
                .subscribe(function () {
                _this.isSlect1020default = false;
                _this.populateTimeEntryGridDataSource(_this.userEmployment.Id, _this.selectedSalaryPeriodId);
            });
        }
    };
    EmployeeTimeComponent.prototype.EmptyEmployeetime = function () {
        if (this.TimeEntryRecords && this.TimeEntryRecords.length > 0) {
            return '';
        }
        else {
            return 'EmptydataGrid';
        }
    };
    EmployeeTimeComponent.prototype.EmptyEmployeePreview = function () {
        if (this.newPreviewData && this.newPreviewData.length > 0) {
            return '';
        }
        else {
            return 'EmptydataGrid';
        }
    };
    EmployeeTimeComponent.prototype.onSalaryperiodsMobileCentricChange = function () {
        this.tempselectedSalaryPeriodId = undefined;
        this.onSalaryPeriodChanged('');
    };
    EmployeeTimeComponent.prototype.updateEditableFieldsAndClasses = function (dataItem) {
        var timeEntryType = this.TimeEntryTypes && this.TimeEntryTypes.length > 0
            ? this.TimeEntryTypes.find(function (e) { return e.TimeEntryTypeId === dataItem.TimeEntryTypeId; })
            : undefined;
        dataItem.isEditUnitType = timeEntryType ? timeEntryType.AllowEditUnitType : false;
        dataItem.ClassIsEditUnitType = 'grid-disable-cell'; //dataItem.isEditUnitType ? '' : 'grid-disable-cell';
        var unitType = this.UnitTypes && this.UnitTypes.length > 0
            ? this.UnitTypes.find(function (type) { return type.Id === dataItem.UnitTypeId; })
            : undefined;
        dataItem.isEditStartAndEndTime = unitType ? unitType.Key === 'Hours' : false;
        dataItem.ClassIsEditStartAndEndTime = dataItem.isEditStartAndEndTime ? '' : 'grid-disable-cell';
        if (dataItem.isEditStartAndEndTime) {
            dataItem.isEditUnits = dataItem.StartTime && dataItem.EndTime ? false : true;
        }
        else {
            dataItem.isEditUnits = dataItem.EntryDate && dataItem.EndDate ? false : true;
        }
        dataItem.ClassIsEditUnits = dataItem.isEditUnits ? '' : 'grid-disable-cell';
        dataItem.TimeEntryTypeName = timeEntryType && timeEntryType.Name ? timeEntryType.Name : '';
        if (dataItem.Status) {
            if ((dataItem.Status.Key === 'Open' || dataItem.Status.Key === 'EmployeeApproved') &&
                (this.IsReadOnly || this.isManager || this.isSalaryAdminAndHigher)) {
                dataItem.isDisableRejectbutton = false;
            }
            else if (dataItem.Status.Key === 'ManagerApproved' && this.isSalaryAdminAndHigher) {
                dataItem.isDisableRejectbutton = false;
            }
            else {
                dataItem.isDisableRejectbutton = true;
            }
        }
        dataItem.isvisibleDeletebytton =
            dataItem.Status &&
                (dataItem.Status.Key === 'Rejected' ||
                    dataItem.Status.Key === 'Open' ||
                    (dataItem.Status.Key === 'EmployeeApproved' && !this.isSalaryAdminAndHigher));
        dataItem.rejectbuttonClass = dataItem.isDisableRejectbutton ? 'Reject k-button Disable' : 'Reject k-button';
    };
    EmployeeTimeComponent.prototype.onKeyDown = function (event) {
        if (!this.IsReadOnly) {
            if (event.keyCode in this.keyPress) {
                this.keyPress[event.keyCode] = true;
                if (this.keyPress[17] && this.keyPress[18] && this.keyPress[109]) {
                    if (this.isAllowEditGridOption) {
                        if (this.selectedItem && this.TimeEntryRecords && this.TimeEntryRecords.length > 0) {
                            var deleteArgs = {};
                            deleteArgs.dataItem = this.selectedItem;
                            this.onDeleteRow(deleteArgs);
                            this.setKeypress();
                            this.triggerUpdate = true;
                        }
                    }
                    else {
                        this.isDisableAddNew = true;
                        this.setKeypress();
                    }
                }
            }
            else {
                this.setKeypress();
            }
        }
    };
    EmployeeTimeComponent.prototype.setKeypress = function () {
        this.keyPress[17] = false;
        this.keyPress[18] = false;
        this.keyPress[107] = false;
        this.keyPress[109] = false;
    };
    EmployeeTimeComponent.prototype.createFormGroup = function (dataItem) {
        return new FormGroup({
            Id: new FormControl(dataItem ? dataItem.Id : undefined),
            TimeEntryTypeId: new FormControl(dataItem ? dataItem.TimeEntryTypeId : undefined),
            EntryDate: new FormControl(dataItem ? dataItem.EntryDate : undefined),
            EndDate: new FormControl(dataItem ? dataItem.EndDate : undefined),
            Units: new FormControl(dataItem ? dataItem.Units : undefined),
            StartTime: new FormControl(dataItem ? dataItem.StartTime : undefined),
            EndTime: new FormControl(dataItem ? dataItem.EndTime : undefined),
            Description: new FormControl(dataItem ? dataItem.Description : undefined),
            DepartmentName: new FormControl(dataItem ? dataItem.DepartmentName : undefined),
            UnitTypeId: new FormControl(dataItem ? dataItem.UnitTypeId : undefined),
            UnitType: new FormControl(dataItem ? dataItem.UnitType : undefined),
            Created: new FormControl(dataItem ? dataItem.Created : undefined),
            SalaryPeriodId: new FormControl(dataItem ? dataItem.SalaryPeriodId : undefined),
            UserEmploymentId: new FormControl(dataItem ? dataItem.UserEmploymentId : undefined),
            Status: new FormControl(dataItem ? dataItem.Status : undefined),
            KilometersDriven: new FormControl(dataItem ? dataItem.KilometersDriven : undefined)
        });
    };
    EmployeeTimeComponent.prototype.onFilterChange = function (filter) {
        this.filter = filter;
        if (filter && filter.filters && filter.filters.length > 0) {
            var filterDateTimeGrid = new FilterDateTimeGrid();
            var filtersDate = [];
            // Using FilterDateTimeGrid to filter date before filter another field
            this.filter = filterDateTimeGrid.convertFilterOperator(filter, filtersDate, 'EntryDate', 'EndDate');
            this.TimeEntryRecords = filterDateTimeGrid.doFilterDate(this.DefaultTimeEntryRecord, filtersDate, 'EntryDate', 'EndDate');
            this.TimeEntryRecords = filterBy(this.TimeEntryRecords, this.filter);
            if (filtersDate.length > 0) {
                [].push.apply(this.filter.filters, filtersDate);
            }
        }
        else {
            this.TimeEntryRecords = this.DefaultTimeEntryRecord;
            this.SelectedTimeStatusId = -1;
            this.timeStatusChanged();
        }
    };
    EmployeeTimeComponent.prototype.onExpand = function (event) {
        this.expanded = event;
    };
    EmployeeTimeComponent.prototype.onAddNewItem = function () {
        if (!this.sessionService.isSubmitting) {
            this.isAddNew = true;
        }
    };
    return EmployeeTimeComponent;
}());
export { EmployeeTimeComponent };
